.invite {
	display: flex;
	gap: var(--size-3);
	margin-top: var(--size-3);
	margin-bottom: var(--size-5);
}

.email {
	flex: 1;
}

.list {
	all: unset;
	list-style: none;
	display: flex;
	flex-direction: column;
	gap: var(--size-3);
}

.row {
	display: grid;
	grid-template-columns: var(--size-7) 1fr auto;
	justify-items: center;
	align-items: center;
	gap: var(--size-3);
}

.info {
	min-width: 0;
	justify-self: start;
	display: flex;
	flex-direction: column;
}

.buttons {
	display: flex;
	align-items: center;
	gap: var(--size-2);
	flex-shrink: 0;
}

.meta {
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}

.empty {
	background-color: var(--color-surface-elevated);
	border-radius: var(--radius-md);
	text-align: center;
	padding: var(--size-4);
	color: var(--color-text-subtle);
}

.actions {
	margin-top: var(--size-6);
	display: flex;
	align-items: center;
	gap: var(--size-3);
	justify-content: flex-end;
}

.error {
	color: var(--color-error-text);
	font-size: var(--text-caption);
	margin-bottom: var(--size-4);

	&:empty {
		display: none;
	}
}
